import { Button, Input } from "@ui";
import style from "./PaymentSystems.module.scss";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import { useGetAdminWalletQuery, useUpdateAdminWalletMutation } from "@RTKQuery/admin/wallet/wallet";

export function PaymentSystems() {
    const { data, isFetching } = useGetAdminWalletQuery();

    const [updateAdminWallet, updateStatus] = useUpdateAdminWalletMutation()

    return (
        <div className={style.container}>
            <Formik
                initialValues={{
                    trc20: data?.usdt_wallet || ""
                }}
                validationSchema={Yup.object({
                    trc20: Yup.string().required("Адреса TRC20 - обов'язкове поле"),
                })}
                onSubmit={(values, actions) => {
                    updateAdminWallet({
                        usdt_wallet: values.trc20
                    })
                }}
                enableReinitialize
            >
                {props => (
                    <Form>
                        <div className={style.listSystems}>
                            <div className={style.system}>
                                <p className={style.systemName}>TRC 20:</p>
                                <Input
                                    label="Адреса TRC20"
                                    customStyle={{
                                        width: "!max-w-[500px]"
                                    }}
                                    type="text"
                                    onChange={(newValue) => {
                                        props.setFieldValue("trc20", newValue)
                                    }}
                                    onBlur={props.handleBlur}
                                    value={props.values.trc20}
                                    name="trc20"
                                    error={props.touched.trc20 ? props.errors.trc20 : ""}
                                    actions={isFetching ? "load" : undefined}
                                />
                            </div>
                        </div>
                        <div className={style.btnContainer}>
                            <Button
                                type="submit"
                                text="Зберегти"
                                color="blue"
                                customStyle={{
                                    button: "!px-[60px] !w-[190px] !h-[40px] max-sm:!w-full",
                                    text: "!text-[14px]"
                                }}
                                successContent={
                                    updateStatus.isSuccess
                                        ? {
                                            title: "Вітаємо!",
                                            description: <p className="max-w-[260px]">Ви успішно оновили гаманці!</p>
                                        }
                                        : undefined
                                }
                                loading={updateStatus.isLoading}
                                errors={[
                                    (updateStatus.error && ((extractError) => {
                                        return extractError(updateStatus.error)
                                    }))
                                ]}
                                resetStatus={() => {
                                    updateStatus.reset();
                                    props.resetForm()
                                }}
                            />
                            <p className={style.btnLabel}>
                                *Зміни вступлять в дію через <span>декілька хвилин</span> <br /> після додавання нових реквізитів.
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}